<template>
  <b-input-group>
    <b-form-input v-model="inputValue" :placeholder="placeholder" :class="inputClasses" :value="inputValue" @input="onInput"></b-form-input>

    <template #append>
      <selector id="type-sel" name="type-sel" mandatory="false" :placeholder="placeholder" :data="selectValues" :valuefield="valuefield" :textfield="textfield" :inlinerows="selectorInline" :selected="selectedOption" classes="bg-gray" ref="selector" blockLabelClass="col-md-12 pl-0 pr-0" @input="onSelect"></selector>
    </template>
  </b-input-group>
</template>

<script>
import "../../assets/scss/form-group.scss";
import "../../assets/scss/text-input-group.scss";

import Selector from "../atoms/Selector.vue";

export default {
  name: "selector-input-group",

  data() {
    return {
      inputValue: this.default_value,
    };
  },
  created() {},

  props: {
    selectValues: {
      required: true,
    },
    valuefield: {
      type: String,
      required: true,
    },
    textfield: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: "",
    },
    selectorInline: {
      default: false,
    },
    inputClasses: {
      default: "",
    },
    selectedOption: {
      default: 0,
    },

    default_value: {
      type: String,
      default: "",
    },
  },

  methods: {
    onInput(value) {
      this.$emit("onInput", value);
    },
    onSelect(value) {
      this.$emit("onSelect", value);
    },
  },

  components: {
    Selector,
  },
};
</script>
